export default "__VITE_ASSET__c281e016__"